<div class="container-fluid">

    <div class="pageheader d-flex align-items-center justify-content-between mb-2">
        <h4 class="d-flex align-items-center mb-1">
               Emails
         </h4>
    </div>

    <app-card title="Search">

      <form [formGroup]="searchCriteria" autocomplete="off" class="small">

        <div class="row mb-3">
          <div class="col-sm-3">
            <label class="form-label fw-semibold">Case Reference</label>
            <input class="form-control form-control-sm" placeholder="Case Reference" maxlength="250" formControlName="caseReference">
          </div>
          <div class="col-sm-3">
            <label class="form-label fw-semibold">To Email</label>
            <input class="form-control form-control-sm" placeholder="To Email" maxlength="250" formControlName="toEmail">
          </div>
          <div class="col-sm-2">
            <label class="form-label fw-semibold">Queued Date From</label>
            <input type="date" class="form-control form-control-sm" formControlName="queuedDateFrom">
          </div>
          <div class="col-sm-2">
            <label class="form-label fw-semibold">Queued Date To</label>
            <input type="date" class="form-control form-control-sm" formControlName="queuedDateTo">
          </div>
          <div class="col-sm-2">
            <label class="form-label fw-semibold">From User</label>
            <select class="form-select form-select-sm" formControlName="fromUserId">
              <option [value]=""></option>
              <option *ngFor="let user of internalUsers" [value]="user.id">{{user.fullName}}</option>
            </select>
          </div>
        </div>

        <div class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-success btn-sm" (click)="doSearch()">Search</button>
        </div>

      </form>

    </app-card>

     <app-card [title]="resultsTitle">

         <div card-body>

            <table mat-table [dataSource]="results" matSort matSortActive="queuedDate" matSortDisableClear matSortDirection="desc" width="100%">

              <ng-container matColumnDef="caseReference" >
                <mat-header-cell *matHeaderCellDef class="caseref">
                    <span>Case Ref.</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let email" class="caseref"> <span *ngIf="email.case"> {{email.case.caseReference}} </span> </mat-cell>
              </ng-container>

              <ng-container matColumnDef="to" >
                  <mat-header-cell *matHeaderCellDef class="toaddress">
                      <span>To.</span>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let email" class="toaddress"> {{email.to}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="cc" >
                    <mat-header-cell *matHeaderCellDef class="ccaddress">
                        <span>Cc.</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let email" class="ccaddress"> {{email.cc}} </mat-cell>
                  </ng-container>

              <ng-container matColumnDef="subject">
                  <mat-header-cell *matHeaderCellDef >
                      <span>Subject.</span>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let email" > {{email.subject}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="user" >
                    <mat-header-cell *matHeaderCellDef class="username">
                        <span>User.</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let email" class="username"> <span *ngIf="email.user">{{email.user.firstName}} {{email.user.lastName}} </span></mat-cell>
                  </ng-container>

              <ng-container matColumnDef="queuedDate" >
                  <mat-header-cell *matHeaderCellDef class="datecol">
                      <span mat-sort-header>Created Date.</span>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let email" class="datecol"> {{email.queuedDate  | date:'dd/MM/yyyy HH:mm'}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="sentDate" >
                    <mat-header-cell *matHeaderCellDef class="datecol">
                        <span mat-sort-header>Sent Date.</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let email" class="datecol"> {{email.sentDate  | date:'dd/MM/yyyy HH:mm'}} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="error">
                      <mat-header-cell *matHeaderCellDef>
                        <span >Error</span>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let email">
                      <span *ngIf="email.errorCount == 5">{{email.lastErrorMessage}}</span>
                      </mat-cell>
                    </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></mat-header-row>
              <mat-row *matRowDef="let email; columns: displayedColumns;" [ngClass]="{'error': email.errorCount == 5}"></mat-row>

            </table>

            <div class="spinner-container" *ngIf="isLoadingResults">
              <mat-spinner color="primary" diameter="20"></mat-spinner>
          </div>
            <mat-paginator [length]="resultsLength" [pageSize]="100" [pageSizeOptions]="[100, 200, 300]" [showFirstLastButtons]="true"></mat-paginator>

          </div>

        </app-card>

</div>
